import * as React from "react";
import { Controller } from 'react-hook-form';
import { IInput } from '../types/dataForm/types';
import { FormControlLabel } from '@mui/material';
import Switch from '@mui/material/Switch';

export default function InputSwitch({ name, form, label, mb = 2 }: IInput) {
  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          label={label}
          labelPlacement="start"
          sx={{ mb, ml: 0 }}
          //helperText={error ? error.message : null}
          //error={!!error}
          control={
            <Controller
              name={name}
              control={form.control}
              render={({}) => {
                return (
                  <Switch
                    value={value === 'yes' || value === true}
                    onChange={(e) => onChange(e.target.checked ? 'yes' : 'no')}
                    //helperText={error ? error.message : null}
                    //error={!!error}
                  />
                );
              }}
            />
          }
        />
      )}
    />
  );
}
